import {createApp} from "vue";
import App from "./App.vue";
import "@comlinedev/bootstrap5/dist/css/bootstrap.min.css";
import "@comlinedev/bootstrap5/dist/js/bootstrap.bundle.min.js";
import "./registerServiceWorker";
import { onAuthStateChanged } from "firebase/auth";
import {auth} from "./plugins/firebase";
import router from "./plugins/router";
import i18n from "./plugins/i18n";
import store from "./plugins/store";
import {FontAwesomeIcon} from "./plugins/fontawesome";

let app;

onAuthStateChanged(auth, (user) => {
  store.dispatch("fetchUser", user);

  if (!app) {
    app = createApp(App)
      .component("font-awesome-icon", FontAwesomeIcon)
      .provide("$router", router)
      .use(store)
      .use(router)
      .use(i18n)
      .mount("#app");
  }
});
